import { useTranslation } from '../../../hooks/useTranslation';
import type { Product } from '../../../models/Product';
import Carousel from '../../carousel/Carousel';
import ProductCard from '../../product/card/ProductCard';
import './ProductSuggestionsPanel.less';

export type ProductSuggestionsPanelProps = {
    suggestions: {
        products: Product[];
        title: string;
        description: string;
    }[];
    featureType:
        | 'product-search-new'
        | 'product-search-by-text'
        | 'product-search-similar'
        | 'product-search-combinations'
        | 'product-search-complementary-category'
        | 'product-search-similar-by-image'
        | 'product-search-combinations-by-image';
};

const ProductSuggestionsPanel = ({
    suggestions,
    featureType
}: ProductSuggestionsPanelProps) => {
    const { t } = useTranslation();
    return (
        <div className={`bri-ProductSuggestionsPanel`}>
            <div className={`bri-DisplayFont`}>
                {t('PRODUCTS_SUGGESTED_HEADING')}
            </div>
            {suggestions.map((suggestion, index) => (
                <div
                    key={index}
                    className={`bri-ProductSuggestionsPanel-suggestion`}
                >
                    <div>
                        <div className={`bri-Headline2Font`}>
                            {suggestion.title}
                        </div>
                        <div className={`bri-TitleFont`}>
                            {suggestion.description}
                        </div>
                    </div>
                    <Carousel
                        items={suggestion.products.map(product => (
                            <ProductCard
                                product={product}
                                animationDelay={0}
                                source="brilliant"
                                featureType={featureType}
                            />
                        ))}
                        stepSize={4}
                        visibleItems={5}
                        gap={16}
                    />
                </div>
            ))}
        </div>
    );
};

export default ProductSuggestionsPanel;
